module.exports = __webpack_public_path__ + "img/Wallet_active.1188cbf1.svg";